import { Component, Input } from "@angular/core";
import { EdpModalService } from "../edp-modal.service";
import { IModalData } from "../edp-modal.models";
import { MODAL_TYPE } from "@edp-enums/modal-type.enum";
import { DomSanitizer } from "@angular/platform-browser";
import { environment } from "@edp-environments/environment";

@Component({
    selector: "edp-modal-status",
    templateUrl: "./edp-modal-status.component.html",
    styleUrls: ["./edp-modal-status.component.scss"]
})
export class EdpModalStatusComponent {
    public modalType = MODAL_TYPE;
    public isApp = false;

    @Input() public data: IModalData;

    constructor(
        private edpModalService: EdpModalService,
        private sanitizer: DomSanitizer,
    ) {
        this.isApp = environment.isApp;
    }

    public close(): void {
        this.edpModalService.close(true);
    }

}
